<div *ngIf="loading" style="display: flex; justify-content: center; padding: 20px;">
  <mat-spinner diameter="40"></mat-spinner>
</div>

<mat-card *ngIf="!loading && sharedStudies && sharedStudies.length > 0">
  <mat-card-header>
    <mat-card-title>{{ 'popup.share_study.existing' | translate }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div *ngFor="let share of sharedStudies" class="share">
      <mat-icon [class.material-symbols-outlined]="isSymbolIcon(share)">{{ getShareTypeIcon(share) }}</mat-icon>
      <span>
        {{ share.targetName }}
        <span class="clinic-name" *ngIf="share.clinicName"> ({{ share.clinicName }})</span>
      </span>
      <app-confirm-button
        [label]="'popup.share_study.existing.delete' | translate"
        [labelConfirm]="'popup.share_study.existing.delete_confirm' | translate"
        (clickButton)="delete(share)">
      </app-confirm-button>
    </div>
  </mat-card-content>
</mat-card>
